import { createFileRoute, Navigate } from "@tanstack/react-router";
import type { JSX } from "react";

/** Angular deep-links `/report`; bare `$id` redirects there and keeps query params. */
const ProjectViewIndexRedirect = (): JSX.Element => {
	const { id } = Route.useParams();
	const search = Route.useSearch();
	return <Navigate params={{ id }} search={search} to="/settings/projectview/$id/report" />;
};

export const Route = createFileRoute("/settings/projectview/$id/")({
	validateSearch: (
		search: Record<string, unknown>
	): {
		readonly workspaceid?: string;
		readonly in_teams?: string;
	} => ({
		workspaceid: typeof search.workspaceid === "string" ? search.workspaceid : undefined,
		in_teams: typeof search.in_teams === "string" ? search.in_teams : undefined,
	}),
	component: ProjectViewIndexRedirect,
});
